/**
 * Semantic colour tokens. Use these in pages instead of raw palette keys:
 *   surface.* (backgrounds) · text.* (foreground) · border.* · status.{success|warning|danger|info|neutral}.{solid|bg|fg|border}
 * Light mode only — no `_dark` keys by design.
 */
export const semanticTokens = {
  colors: {
    "surface.canvas": "#F6F4EF",
    "surface.card": "#FFFFFF",
    "surface.sunken": "sand.100",
    "surface.inverse": "navy.900",
    "surface.overlay": "rgba(11,16,53,0.55)",

    "text.primary": "navy.900",
    "text.secondary": "sand.700",
    "text.muted": "sand.600",
    "text.faint": "sand.500",
    "text.inverse": "#FFFFFF",
    "text.inverseMuted": "navy.200",
    "text.link": "navy.500",
    "text.onGreen": "navy.900",
    "text.success": "leaf.700",
    "text.danger": "red.600",

    "border.default": "sand.200",
    "border.strong": "sand.300",
    "border.rule": "rgba(19,27,77,0.18)",
    "border.brand": "leaf.500",
    "border.onDark": "rgba(255,255,255,0.12)",

    "status.success.solid": "leaf.600",
    "status.success.bg": "leaf.100",
    "status.success.fg": "leaf.900",
    "status.success.border": "leaf.200",
    "status.warning.solid": "amber.500",
    "status.warning.bg": "amber.100",
    "status.warning.fg": "amber.800",
    "status.warning.border": "amber.300",
    "status.danger.solid": "red.500",
    "status.danger.bg": "red.100",
    "status.danger.fg": "red.800",
    "status.danger.border": "red.300",
    "status.info.solid": "navy.500",
    "status.info.bg": "navy.50",
    "status.info.fg": "navy.700",
    "status.info.border": "navy.100",
    "status.neutral.solid": "sand.500",
    "status.neutral.bg": "sand.100",
    "status.neutral.fg": "sand.700",
    "status.neutral.border": "sand.200",
    "status.brand.solid": "leaf.500",
    "status.brand.bg": "leaf.50",
    "status.brand.fg": "leaf.900",
    "status.brand.border": "leaf.200",
  },
};

/** Gradient strings (Chakra tokens cannot hold gradients). Use as `bg={gradients.sidebar}` or via layerStyles. */
export const gradients = {
  sidebar: "linear-gradient(180deg, #131B4D 0%, #0B1035 100%)",
  hero: "radial-gradient(60% 120% at 100% 0%, rgba(107,191,89,0.28) 0%, rgba(107,191,89,0) 60%), #131B4D",
  loginStage: "linear-gradient(180deg, #0B1035 0%, #131B4D 100%)",
  /** Faint dot grid for the login action column. */
  dotGrid: "radial-gradient(#D6D2C6 1px, transparent 1px)",
};
